import { ICotacao } from '../../shared/services/api/mercado';

const numero = (valor: number, casas: number) => valor.toLocaleString('pt-BR', {
  minimumFractionDigits: casas,
  maximumFractionDigits: casas,
});

// Casas decimais por tipo de cotação — câmbio com 4 (como o mercado lê o
// dólar), valores grandes (bitcoin, cobre, Ibovespa) sem centavos.
const casasDecimais = (cotacao: ICotacao) => {
  if (cotacao.categoria === 'moeda' && cotacao.valor < 100) return 4;
  if (cotacao.categoria === 'indice' || cotacao.valor >= 10000) return 0;
  return 2;
};

export const formatarValorCotacao = (cotacao: ICotacao) => {
  const valor = numero(cotacao.valor, casasDecimais(cotacao));
  if (cotacao.categoria === 'indicador') return `${valor}%`;
  if (cotacao.unidade.startsWith('R$')) return `R$ ${valor}`;
  if (cotacao.unidade.startsWith('US$')) return `US$ ${valor}`;
  return valor;
};

// Unidade que sobra depois do símbolo da moeda (ex: 'R$/l' -> '/l').
export const sufixoUnidade = (cotacao: ICotacao) => {
  if (cotacao.categoria === 'indicador') return 'a.a.';
  if (cotacao.unidade === 'R$' || cotacao.unidade === 'US$') return '';
  return cotacao.unidade.replace(/^(R\$|US\$)/, '');
};

export const formatarValorBRL = (cotacao: ICotacao) => {
  if (cotacao.valorBRL === undefined || !cotacao.unidadeBRL) return null;
  const casas = cotacao.valorBRL >= 10000 ? 0 : 2;
  return `≈ R$ ${numero(cotacao.valorBRL, casas)}${cotacao.unidadeBRL.replace(/^R\$/, '')}`;
};

// Indicador (Selic, IPCA...) já é um percentual: a variação é em pontos
// percentuais, não em % do valor.
export const formatarVariacao = (cotacao: ICotacao) => {
  if (cotacao.variacao === null) return null;
  const sinal = cotacao.variacao > 0 ? '+' : '';
  return cotacao.categoria === 'indicador'
    ? `${sinal}${numero(cotacao.variacao, 2)} p.p.`
    : `${sinal}${numero(cotacao.variacao, 2)}%`;
};

export const tempoRelativo = (dataIso: string) => {
  const data = new Date(dataIso);
  const minutos = Math.round((Date.now() - data.getTime()) / 60000);
  if (!Number.isFinite(minutos)) return '';
  if (minutos < 1) return 'agora';
  if (minutos < 60) return `há ${minutos} min`;
  const horas = Math.round(minutos / 60);
  if (horas < 24) return `há ${horas} h`;
  const dias = Math.round(horas / 24);
  if (dias === 1) return 'ontem';
  if (dias < 7) return `há ${dias} dias`;
  return data.toLocaleDateString('pt-BR');
};
